import { Tenants, Languages } from 'entities/Config'

export const getTenant = () =>
  // eslint-disable-next-line no-underscore-dangle
  (global as any)._saeConversational?.tenant || Tenants.COM

export const getLanguage = () =>
  // eslint-disable-next-line no-underscore-dangle
  (global as any)._saeConversational?.language || Languages.DE
